<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom: 40px;">Dedication</h1>
<p>To my amazing wife, Nicole, I thank you for all of your love and support and I love you dearly. Thank you to my dad (Stephen Conroy) as well, who concocted the greatest camp fire story of all time and you are greatly missed every day. To my mother, Robin Brand, I just simply cannot state enough how thankful I am for everything you do and your continuous support and love. Thank you to all of my family.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?40e37f04